import { jsxs as t, jsx as r } from "react/jsx-runtime";
import { Paragraph as s } from "../../../atoms/Paragraph/Paragraph.es.js";
import { chakra as a } from "@chakra-ui/react";
import { useSharedFooterStyle as e } from "../SharedFooter.context.es.js";
import { PlatformInstagramBorderIcon as m, PlatformTikTokColorIcon as c, PlatformYouTubeColorIcon as l, PlatformSnapchatColorIcon as i } from "../../../icons/index.es.js";
const x = () => {
  const o = e();
  return /* @__PURE__ */ t(a.div, { __css: o.social, children: [
    /* @__PURE__ */ r(m, { sx: o.socialItem }),
    /* @__PURE__ */ r(c, { sx: o.socialItem }),
    /* @__PURE__ */ r(l, { sx: o.socialItemYoutube }),
    /* @__PURE__ */ r(i, { sx: o.socialItem }),
    /* @__PURE__ */ r(s, { __css: o.socialDescription, children: "Partners" })
  ] });
};
export {
  x as SharedFooterPlatforms
};
//# sourceMappingURL=SharedFooterPlatforms.es.js.map
